export const SET_KEY_STORE_DATA_VERSION = "SET_KEY_STORE_DATA_VERSION";
export const SET_BROWSE_CURRENCY = "SET_BROWSE_CURRENCY";
export const KSDV_PROPS_OVERWRITE = [
  "storeCode",
  "siteId",
  "currencies",
  "sizeSchemas",
  "defaultLanguage",
  "defaultSizeSchema",
  "defaultCurrency",
  "storeUrls"
];
export const SEARCH_PATH = "search/";



// WEBPACK FOOTER //
// ./template/state/modules/regionalStore/constants.js